<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nsvm8K/tc-custom/9781609455880.jpg?1704299963811" alt="This image is the cover for the book Breasts and Eggs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breasts and Eggs
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel that “considers the agency . . . women exert over their bodies and charts the emotional underpinnings of physical changes . . . with humor and empathy” (<i>The New Yorker</i>).</b><br/><br/>On a sweltering summer day, Makiko travels from Osaka to Tokyo, where her sister Natsu lives. She is in the company of her daughter, Midoriko, who has lately grown silent, finding herself unable to voice the vague yet overwhelming pressures associated with adolescence. Over the course of their few days together in the capital, Midoriko’s silence will prove a catalyst for each woman to confront her fears and family secrets.<br/><br/>On yet another summer’s day eight years later, Natsu, during a journey back to her native city, confronts her anxieties about growing old alone and childless.<br/><br/>Bestselling author Mieko Kawakami mixes stylistic inventiveness and riveting emotional depth to tell a story of contemporary womanhood in Japan.<br/><br/>“Took my breath away.” —Haruki Murakami, #1 <i>New York Times–</i>bestselling author <i>The Wind-Up Bird Chronicle</i><br/><br/>“Kawakami lobbed a literary grenade into the fusty, male-dominated world of Japanese fiction with <i>Breast and Eggs</i>.” —<i>The Economist</i><br/><br/>“A sharply observed and heartbreaking portrait of what it means to be a woman.” —<i>TIME</i><br/><br/>“Raw, funny, mundane, heartbreaking.” —<i>The Atlantic</i><br/><br/>“A bracing, feminist exploration of daily life in Japan.” —<i>Entertainment Weekly</i><br/><br/>“Timely feminist themes; strange, surreal prose; and wonderful characters will transcend cultural barriers and enchant readers.” —<i>The New York Observer</i><br/><br/>“Bracing and evocative, tender yet unflinching.” —<i>Publishers Weekly</i><br/><br/>“Kawakami writes with unsettling precision about the body—its discomforts, its appetites, its smells and secretions. And she is especially good at capturing its longings.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mieko Kawakami
      </h2>
      
      <p class="authorDescription body article"><P><B>Mieko Kawakami</B> is the author of the international bestseller <I>Breasts and Eggs</I>, a 2020 <I>New York Times</I> Notable Book of the Year, and the highly acclaimed <I>Heaven</I>, one of <I>TIME</I>’s Best Books of 2021. Her most recent novel is <I>All the Lovers in the Night</I>, which Hamilton Cain described as “her most accomplished novel yet” in <I>Oprah Daily</I>. Born in Osaka, Kawakami made her literary debut as a poet in 2006, and in 2007 published her first novella,<I> My Ego, My Teeth, and the World</I>. Known for their poetic qualities, insights into the female body, and preoccupation with ethics and modern society, her books have been translated into over twenty languages and are available all over the world. Kawakami’s literary awards include the Akutagawa Prize, the Tanizaki Prize, and the Murasaki Shikibu Prize. She lives in Tokyo.</P><br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c06ccb1c